import { render } from "./BannerDetail.vue?vue&type=template&id=7831d364&scoped=true"
import script from "./BannerDetail.vue?vue&type=script&lang=js"
export * from "./BannerDetail.vue?vue&type=script&lang=js"

import "./BannerDetail.vue?vue&type=style&index=0&id=7831d364&scoped=true&lang=css"

import exportComponent from "/Users/kellyluo/Work/projects/icheer-web-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7831d364"]])

export default __exports__